import {CourseAssignmentStateEnum, UserStatusEnum} from 'src/api/ProactApiClient';

/** Course assignment states a trainee still has to act on. */
export const OPEN_COURSE_ASSIGNMENT_STATES = [
  CourseAssignmentStateEnum.Open,
  CourseAssignmentStateEnum.Pending,
];

/** User states whose course assignments appear in "my courses" lists. */
export const ASSIGNABLE_USER_STATES = [
  UserStatusEnum.Active,
  UserStatusEnum.Pending,
];
